import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideTransloco } from '@jsverse/transloco';
import { TranslocoHttpLoader } from './_shared/i18n/transloco-loader';
import { LanguageService } from './_shared/services/language.service';
import { AVAILABLE_LANGUAGES, DEFAULT_LANGUAGE } from './_shared/i18n/languages.constant';

import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { Environment } from './_shared/models/environment.model';
import { HttpClientModule } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';
import { ToastComponent } from './_shared/components/toast/toast.component';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './_shared/interceptors/auth.interceptor';
import { GoogleLoginProvider, MicrosoftLoginProvider, SocialAuthServiceConfig } from '@abacritt/angularx-social-login';
import { BlockUIModule } from 'ng-block-ui';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';


const env: Environment = environment as Environment;

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptors([authInterceptor])),
    provideRouter(routes),
    importProvidersFrom(HttpClientModule),
    provideAnimations(), 
    provideToastr({ toastComponent: ToastComponent, closeButton: true }),
    provideCharts(withDefaultRegisterables()),
    importProvidersFrom(BlockUIModule.forRoot()),
    provideTransloco({
      config: {
        availableLangs: AVAILABLE_LANGUAGES.map((language) => language.code),
        defaultLang: DEFAULT_LANGUAGE,
        fallbackLang: DEFAULT_LANGUAGE,
        reRenderOnLangChange: true,
        prodMode: environment.production,
        missingHandler: {
          useFallbackTranslation: true,
          logMissingKey: !environment.production,
        },
      },
      loader: TranslocoHttpLoader,
    }),
    {
      provide: APP_INITIALIZER,
      useFactory: (languageService: LanguageService) => () => languageService.init(),
      deps: [LanguageService],
      multi: true,
    },
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
              environment.socialLoginConfig.google.clientId, { oneTapEnabled: false })
          },
          {
            id: MicrosoftLoginProvider.PROVIDER_ID,
            provider: new MicrosoftLoginProvider(environment.socialLoginConfig.microsoft.clientId, {
              redirect_uri: `${window.location.origin}/auth-callback`,
              prompt: 'select_account'
            })
          }
        ],
        onError: (err) => {
          console.error(err);
        }
      } as SocialAuthServiceConfig,
    }
  ]
};